module.exports = __webpack_public_path__ + "static/media/Pantry-Party-Site-Display.5f166a42.gif";